<template>
  <q-dialog
    v-on:show="onDialogShown"
    v-model="this.showDialog"
    persistent
    full-width
    full-height
    maximized
  >
    <div ref="dialogContainer" class="container no-shadow overflow-hidden" style="flex-direction: row; justify-content: center">
      <div
        ref="floatingMenuBar"
        class="floating-menu-bar"
        :style="{ opacity: (dialogHasOpenedFully ? 1 : 0), width: floatingMenuBarWidthValue }"
      >
        <div class="col floating-menu-bar-section bg-lightGrey">
          <div class="row">
            <span class="full-width text-center text-dark">View Options</span>
          </div>
          <div class="row q-mt-md">
            <span class="full-width text-center menu-text-header">All text</span>
          </div>
          <div class="row">
            <div class="col"><q-btn class="full-width" icon="mdi-format-font-size-increase" @click="changeTextSize(true, ['header','body','date'])" /></div>
            <div class="col"><q-btn class="full-width" icon="mdi-format-font-size-decrease" @click="changeTextSize(false, ['header','body','date'])"/></div>
          </div>
          <div class="row q-mt-md">
            <span class="full-width text-center menu-text-header">Title</span>
          </div>
          <div class="row">
            <div class="col text-center q-my-auto">Font size</div>
            <div class="col"><q-input dense class="text-center" v-model="headerTextSize" v-on:input="refreshTextSizes()" type="number"></q-input></div>
          </div>
          <div class="row">
            <q-checkbox v-model="makeTitleBold">Use bold font</q-checkbox>
          </div>
          <div class="row q-mt-sm">
            <span class="full-width text-center menu-text-header">Body</span>
          </div>
          <div class="row">
            <div class="col text-center q-my-auto">Body font size</div>
            <div class="col"><q-input dense class="text-center" v-model="bodyTextSize" v-on:input="refreshTextSizes()" type="number"></q-input></div>
          </div>
          <div class="row q-mt-lg">
            <span class="full-width text-center menu-text-header">Extra Details</span>
          </div>
          <div class="row">
            <q-checkbox v-model="showWeldedOutcomes" @input="drawOutcomeImagesCanvas">Show outcomes</q-checkbox>
          </div>
          <div class="row">
            <div class="col"><q-btn class="full-width" icon="mdi-image-plus-outline" @click="changeWeldedOutcomeImageSize(true)" /></div>
            <div class="col"><q-btn class="full-width" icon="mdi-image-minus-outline" @click="changeWeldedOutcomeImageSize(false)"/></div>
          </div>
          <div class="row">
            <q-checkbox v-model="showDateText">Show date text</q-checkbox>
          </div>
          <div class="row">
            <div class="col text-center q-my-auto">Date font size</div>
            <div class="col"><q-input dense class="text-center" v-model="dateTextSize" v-on:input="refreshTextSizes()" type="number"></q-input></div>
          </div>
        </div>
      </div>
      <div
        ref="floatingCloseBar"
        class="floating-close-bar items-start"
        style="height: fit-content"
        :style="{ opacity: (dialogHasOpenedFully ? 1 : 0) }"
      >
        <div class="col floating-menu-bar-section">
          <div class="bg-lightGrey" style="border-radius: 50%; width: fit-content">
            <q-btn flat round icon="mdi-close" @click="this.closeFunction" />
          </div>
        </div>
        <div class="col floating-menu-bar-section bg-lightGrey q-mt-lg">
          <div class="row">
            <span class="full-width text-center text-dark">Select Preset</span>
          </div>
          <div class="row">
            <div class="col"><q-btn class="full-width" @click="applyPreset(720, 720, 0.5)">Square</q-btn></div>
            <div class="col"><q-btn class="full-width" @click="applyPreset(720, 935, 0.5)">Portrait</q-btn></div>
          </div>
        </div>

        <div class="col floating-menu-bar-section bg-lightGrey q-mt-lg">
          <div class="row">
            <span class="full-width text-center text-dark">Shadow and Corners</span>
          </div>
          <div class="row">
            <q-checkbox v-model="showDropShadow">Include drop shadow<q-tooltip>Drop shadows are only included in .png downloads</q-tooltip></q-checkbox>
          </div>
          <div class="row" v-if="showDropShadow">
            <div class="col text-center q-my-auto">Size</div>
            <div class="col"><q-input v-model.number="shadowSize" type="number" min="0" max="24" dense v-on:change="updateShadow"></q-input></div>
          </div>
          <div class="row">
            <q-checkbox v-model="shouldRoundCorners">Rounded corners<q-tooltip>Corners may only be rounded in .png downloads</q-tooltip></q-checkbox>
          </div>
          <div class="row" v-if="shouldRoundCorners">
            <div class="col text-center q-my-auto">Radius</div>
            <div class="col"><q-input v-model.number="cornerRadius" type="number" min="0" max="24" dense v-on:change="updateShadow"></q-input></div>
          </div>
          <div class="row q-mt-sm full-width">
            <q-btn class="full-width" label="Preview" @click="previewImage"></q-btn>

            <q-dialog v-model="showImagePreview">
              <q-card style="max-height: 80vh; max-width: 800px">
                <q-card-section>
                  <div class="text-h6">Image Preview</div>
                </q-card-section>

                <q-card-section style="height: auto; max-height: 70vh; display: flex; align-items: center; justify-content: center;">
                  <img style="max-height: 70vh; width: auto; max-width: 100%; object-fit: contain" :src="previewImageData" alt="Loading..." />
                </q-card-section>

                <q-card-actions>
                  <q-btn flat label="Close" color="primary" v-close-popup></q-btn>
                </q-card-actions>
              </q-card>
            </q-dialog>
          </div>
        </div>

        <div class="col floating-menu-bar-section bg-lightGrey q-mt-lg">
          <div class="row">
            <span class="full-width text-center text-dark">Export as...</span>
          </div>
          <div class="row">
            <div class="col"><q-btn class="full-width" @click="exportImage('png')">png</q-btn></div>
            <div class="col"><q-btn class="full-width" @click="exportImage('jpg')">jpg<q-tooltip>Please note: Drop shadows and rounded corners are only included in .png downloads</q-tooltip></q-btn></div>
          </div>
        </div>
      </div>
      <vue-resizable
        style="order: 2"
        class="resizable"
        :active="['r', 'rb', 'b']"
        :fit-parent="true"
        :width="width"
        :min-width="200"
        :min-height="300"
        :height="height"
        @mount="eHandler"
        @maximize="eHandler"
      >
        <div ref="resizableComponent" class="resizable-block" >
          <div ref="storyContainer"
               id="storyContainer"
               class="full-height full-width bg-lightGrey flex" style="flex-direction: column"
          >
            <vue-resizable
              style="width: 100%; flex-grow: 0"
              :active="['b']"
              :height="imageHeight"
            >
              <div
                :style="{backgroundImage: 'url(\'' + this.imageData + '\')', backgroundSize: 'cover', backgroundPosition: 'center center' }"
                class="full-height full-width q-pt-sm q-pr-sm"
              >
                <div id="outcomeImagesBar" class="row justify-end" v-if="this.weldedOutcomeImageDataUrls" />
              </div>
            </vue-resizable>
            <div class="row full-width" style="flex-grow: 1">
              <div class="col-12 q-pa-md" style="display: flex; flex-direction: column; justify-content: space-between; height: 100%">
                <div class="col">
                  <div ref="headerText" class="text-accent" style="font-size: x-large" :style="{fontWeight: makeTitleBold ? 'bold' : 'normal' }">
                    {{ story.title }}
                  </div>
                  <div ref="bodyText" class="text-accent">
                    {{ story.description }}
                  </div>
                </div>
                <div ref="dateText" class="text-accent" style="text-align: end" v-if="showDateText">
                  {{ story.completed_at }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </vue-resizable>
    </div>
  </q-dialog>
</template>

<script>
import VueResizable from 'vue-resizable';
import html2canvas from "html2canvas";
import {getOutcomeImage} from "@/functions/getOutcomeImage";
import {mapGetters} from "vuex";
import {loadImageToDataUrl} from "@/utils/imageUtils";

export default {
  name: "ExpandedStoryView",
  components: { VueResizable },
  computed: {
    ...mapGetters({
      outcomeKeyReferenceList: "outcomes/keyReferenceList",
    })
  },
  props: {
    story: Object,
    closeFunction: Function,
    isVisible: Boolean
  },
  watch: {
    isVisible: {
      immediate: true,
      handler(val) {
        this.showDialog = val;
      }
    }
  },
  data: () => ({
    dialogHasOpenedFully: false,
    showDialog: false,
    showImagePreview: false,
    previewImageData: null,
    width: 720,
    height: 935,
    imageHeight: 0,
    preferredWidth: 720,
    preferredHeight: 935,
    preferredImageProportion: 1/2,
    imageData: null,
    floatingMenuBarWidthValue: '0px',
    headerFontSizeAdjustAmount: 1,
    bodyFontSizeAdjustAmount: 1,
    weldedOutcomesImageSizePercentage: 10,
    makeTitleBold: true,
    showDropShadow: true,
    showWeldedOutcomes: true,
    showDateText: true,
    weldedOutcomeImageUrls: [],
    weldedOutcomeImageDataUrls: [],
    shouldRoundCorners: true,
    shadowSize: 2,
    cornerRadius: 2,
    headerTextSize: 32,
    bodyTextSize: 20,
    dateTextSize: 20,
  }),
  mounted() {
    window.addEventListener('resize', this.updateFloatingCloseBarWidth);
    window.addEventListener('resize', () => this.eHandler({}));
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.updateFloatingCloseBarWidth);
    window.removeEventListener('resize', () => this.eHandler({}));
  },
  methods: {
    getOutcomeImage,
    eHandler(data) {
      if(data.height && data.height > 0) this.preferredHeight = data.height;
      if(data.width && data.width > 0) this.preferredWidth = data.width;

      // If either dimensions will go outside bounds of viewport, resize proportionally so that they fit
      if(!this.$refs.dialogContainer || !this.$refs.dialogContainer.getBoundingClientRect()) return;
      let heightRatio = this.preferredHeight / (this.$refs.dialogContainer.getBoundingClientRect().height - 75);
      let widthRatio = this.preferredWidth / (this.$refs.dialogContainer.getBoundingClientRect().width - this.$refs.floatingMenuBar.getBoundingClientRect().width - this.$refs.floatingCloseBar.getBoundingClientRect().width - 48);
      this.width = this.preferredWidth;
      this.height = this.preferredHeight;

      if(heightRatio > 1 || widthRatio > 1) {
        let scaleDownFactor = 1 / Math.max(heightRatio, widthRatio);
        this.height = this.preferredHeight * scaleDownFactor;
        this.width = this.preferredWidth * scaleDownFactor;
      }
      this.imageHeight = this.height * this.preferredImageProportion;
      this.updateFloatingCloseBarWidth();
    },
    async onDialogShown() {
      this.eHandler({});
      setTimeout(this.updateFloatingCloseBarWidth, 0);
      this.dialogHasOpenedFully = true;
      const imageUrl = (this.story.imgUrl) ? this.story.imgUrl : 'https://upstreamnz.s3.ap-southeast-2.amazonaws.com/Sustainability+Plans/oatas_default.png';
      this.imageData = await loadImageToDataUrl(imageUrl);
      for (let outcome of this.story.outcomes) {
        let url = getOutcomeImage({ name: this.outcomeKeyReferenceList[outcome.outcome_id].name});
        if(this.weldedOutcomeImageUrls.includes(url)) continue;
        this.weldedOutcomeImageUrls.push(url);
        this.weldedOutcomeImageDataUrls.push(await loadImageToDataUrl(url));
      }
      this.drawOutcomeImagesCanvas();
    },
    drawOutcomeImagesCanvas() {
      let outcomeImagesBar = document.getElementById("outcomeImagesBar");
      if (!outcomeImagesBar) return;
      outcomeImagesBar.innerHTML = '';
      if(!this.showWeldedOutcomes) return;
      let maxWidth = outcomeImagesBar.getBoundingClientRect().width;
      for(let imageDataUrl of this.weldedOutcomeImageDataUrls){
        let img = new Image();
        img.src = imageDataUrl;
        img.width = maxWidth * this.weldedOutcomesImageSizePercentage * 0.01;
        img.height = maxWidth * this.weldedOutcomesImageSizePercentage * 0.01;

        img.onload = function() {
          let canvas = document.createElement('canvas')
          canvas.classList.add("expanded-card-view-outcome-image-label");
          canvas.width = img.width;
          canvas.height = img.height;

          let ctx = canvas.getContext('2d');
          ctx.drawImage(img, 0, 0, img.width, img.height);

          outcomeImagesBar.appendChild(canvas);
        }.bind(this);
      }
    },
    updateFloatingCloseBarWidth() {
      const floatingCloseBar = this.$refs.floatingCloseBar;
      if(!floatingCloseBar) return;
      const floatingCloseBarRect = floatingCloseBar.getBoundingClientRect();
      this.floatingMenuBarWidthValue = floatingCloseBarRect.width + "px";
      this.refreshTextSizes();
    },
    changeTextSize(isIncrease, textElements)
    {
      for (const textElement of textElements) {
        if(textElement === 'header') {
          let changeAmount = (parseInt(this.headerTextSize) <= 20) ? 2 : 4;
          this.headerTextSize = parseInt(this.headerTextSize) + ((isIncrease) ? changeAmount : -changeAmount);
        } else if(textElement === 'body') {
          let changeAmount = (parseInt(this.bodyTextSize) <= 20) ? 2 : 4;
          this.bodyTextSize = parseInt(this.bodyTextSize) + ((isIncrease) ? changeAmount : -changeAmount);
        } else if(textElement === 'date') {
          let changeAmount = (parseInt(this.dateTextSize) <= 20) ? 2 : 4;
          this.dateTextSize = parseInt(this.dateTextSize) + ((isIncrease) ? changeAmount : -changeAmount);
        }
      }
      this.refreshTextSizes()
    },
    refreshTextSizes()
    {
      this.$refs.headerText.style.fontSize = this.headerTextSize + "px";
      this.$refs.bodyText.style.fontSize = this.bodyTextSize + "px";
      this.$refs.dateText.style.fontSize = this.dateTextSize + "px";
    },
    changeWeldedOutcomeImageSize(isIncrease)
    {
      let changeAmount = (this.weldedOutcomesImageSizePercentage <= 10) ? 1 : 2;
      this.weldedOutcomesImageSizePercentage += ((isIncrease) ? changeAmount : -changeAmount);
      this.drawOutcomeImagesCanvas();
    },
    applyPreset(width, height, imageHeightProportion)
    {
      this.preferredWidth = width;
      this.preferredHeight = height;
      this.preferredImageProportion = imageHeightProportion;
      this.eHandler({});
      setTimeout(() => this.updateFloatingCloseBarWidth(), 0);
    },
    exportImageAsCanvas(canvasCallbackFunc, allowShadow=true, roundCorners=true)
    {
      let storyCardContainer = this.$refs.storyContainer;
      let that = this;
      html2canvas(storyCardContainer, {useCORS: true}).then(function(canvas) {
        let newCanvas = that.createCanvasWithShadowAndRoundedCorners(canvas, allowShadow ? that.shadowSize : 0, roundCorners ? 0.005 * that.cornerRadius : 0);
        canvasCallbackFunc(newCanvas);
      });
    },
    exportImage(imageType)
    {
      let suggestedFileName = this.story.title.toLowerCase().replaceAll(/\s+/g, '-');
      this.exportImageAsCanvas(function(canvas) {
        let a = document.createElement('a');
        if(imageType === "jpg"){
          a.href = canvas.toDataURL("image/jpeg").replace("image/jpeg", "image/octet-stream");
          suggestedFileName += ".jpg";
        } else {
          a.href = canvas.toDataURL("image/png");
          suggestedFileName += ".png";
        }
        a.download = suggestedFileName;
        a.click();
      }, imageType === "png" && this.showDropShadow, imageType === "png");
    },
    updateShadow()
    {
      if(this.shadowSize < 0) this.shadowSize = 0;
      if(this.shadowSize > 24) this.shadowSize = 24;
    },
    previewImage()
    {
      this.showImagePreview = true;
      let that = this;
      this.exportImageAsCanvas(function(canvas) {
        that.previewImageData = canvas.toDataURL("image/png");
      }, this.showDropShadow, this.shouldRoundCorners);
    },
    createCanvasWithShadowAndRoundedCorners(inputCanvas, shadowSize, cornerRadiusProportion) {
      // Calculate new canvas dimensions
      let cornerRadius = Math.min(inputCanvas.width, inputCanvas.height) * cornerRadiusProportion;
      let newWidth = inputCanvas.width + (4 * shadowSize);
      let newHeight = inputCanvas.height + (4 * shadowSize);

      // Create a new canvas with increased dimensions
      let newCanvas = document.createElement('canvas');
      newCanvas.width = newWidth;
      newCanvas.height = newHeight;

      let ctx = newCanvas.getContext('2d');

      // Draw the shadow by drawing a rounded rectangle and blurring it
      ctx.shadowColor = 'rgba(0, 0, 0, 0.5)';
      ctx.shadowBlur = shadowSize;
      ctx.shadowOffsetX = shadowSize+2;
      ctx.shadowOffsetY = shadowSize+2;
      ctx.fillStyle = '#fff'; // color of the rectangle

      ctx.beginPath();
      ctx.moveTo(shadowSize + cornerRadius, shadowSize);
      ctx.lineTo(shadowSize + inputCanvas.width - cornerRadius, shadowSize);
      ctx.arc(shadowSize + inputCanvas.width - cornerRadius, shadowSize + cornerRadius, cornerRadius, 1.5 * Math.PI, 2 * Math.PI);
      ctx.lineTo(shadowSize + inputCanvas.width, shadowSize + inputCanvas.height - cornerRadius);
      ctx.arc(shadowSize + inputCanvas.width - cornerRadius, shadowSize + inputCanvas.height - cornerRadius, cornerRadius, 0, 0.5 * Math.PI);
      ctx.lineTo(shadowSize + cornerRadius, shadowSize + inputCanvas.height);
      ctx.arc(shadowSize + cornerRadius, shadowSize + inputCanvas.height - cornerRadius, cornerRadius, 0.5 * Math.PI, Math.PI);
      ctx.lineTo(shadowSize, shadowSize + cornerRadius);
      ctx.arc(shadowSize + cornerRadius, shadowSize + cornerRadius, cornerRadius, Math.PI, 1.5 * Math.PI);
      ctx.closePath();
      ctx.fill();

      // Clear the shadow
      ctx.shadowColor = 'transparent';

      // Create a path for a rounded rectangle
      ctx.beginPath();
      ctx.moveTo(shadowSize + cornerRadius, shadowSize);
      ctx.lineTo(shadowSize + inputCanvas.width - cornerRadius, shadowSize);
      ctx.arcTo(shadowSize + inputCanvas.width, shadowSize, shadowSize + inputCanvas.width, shadowSize + cornerRadius, cornerRadius);
      ctx.lineTo(shadowSize + inputCanvas.width, shadowSize + inputCanvas.height - cornerRadius);
      ctx.arcTo(shadowSize + inputCanvas.width, shadowSize + inputCanvas.height, shadowSize + inputCanvas.width - cornerRadius, shadowSize + inputCanvas.height, cornerRadius);
      ctx.lineTo(shadowSize + cornerRadius, shadowSize + inputCanvas.height);
      ctx.arcTo(shadowSize, shadowSize + inputCanvas.height, shadowSize, shadowSize + inputCanvas.height - cornerRadius, cornerRadius);
      ctx.lineTo(shadowSize, shadowSize + cornerRadius);
      ctx.arcTo(shadowSize, shadowSize, shadowSize + cornerRadius, shadowSize, cornerRadius);
      ctx.closePath();

      // Clip to the rounded rectangle path
      ctx.clip();

      // Draw the original image into the new canvas, it will be constrained to the clipping path
      ctx.drawImage(inputCanvas, shadowSize, shadowSize);
      return newCanvas;
    }
  }
}
</script>

<style scoped>

.container {
  display: flex;
  margin-top: auto;
  position: relative;
  padding: 24px;
}

.resizable {
  padding: 0;
  overflow: hidden;
  font-weight: normal;
}

.resizable-block {
  height: 100%;
  width: 100%;
  display: flex;
  position: relative;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.floating-close-bar {
  margin-left: 20px;
  order: 3;
}

.floating-menu-bar {
  order: 1;
  margin-top: 40px;
  margin-right: 20px;
}

.floating-menu-bar-section {
  border-radius: 5px;
  padding: 4px;
}

.menu-text-header {
  font-size: large;
}

</style>

<style>
.expanded-card-view-outcome-image-label:not(:last-child) {
  margin-right: 1%;
}
</style>
